import EmploymentPeriodEditor from './EmploymentPeriodEditor.vue';
import { DocumentValueEditorConfig, DocumentValueInput, DocumentValueMap } from './types';

interface EmploymentPeriodRow extends DocumentValueMap {
  dateFrom?: string | null;
  dateTo?: string | null;
  days?: number | string | null;
}

interface EmploymentPeriodValue extends DocumentValueMap {
  ranges?: EmploymentPeriodRow[];
  totalDays?: number;
}

interface SchemaWithRanges {
  value?: {
    ranges?: {
      $items: unknown[];
      $addRow: () => void;
    };
  };
}

// Ujednolica model wartości; totalDays traktujemy jako źródło prawdy.
function normalizeEmploymentPeriodValue(value: DocumentValueInput = {}): EmploymentPeriodValue {
  const model: EmploymentPeriodValue = Array.isArray(value)
    ? { ranges: value as EmploymentPeriodRow[] }
    : (value as EmploymentPeriodValue) || {};

  const rawTotalDays = Number(model.totalDays);
  const normalizedTotalDays =
    rawTotalDays > 0 && rawTotalDays <= Number.MAX_SAFE_INTEGER ? Math.floor(rawTotalDays) : 0;

  const ranges = Array.isArray(model.ranges)
    ? model.ranges.map(row => ({
        ...row,
        dateFrom: (row && row.dateFrom) || '',
        dateTo: (row && row.dateTo) || ''
      }))
    : [];

  return {
    ...model,
    ranges,
    totalDays: normalizedTotalDays
  };
}

// Buduje pustą wartość startową dla nowo dodawanej pozycji.
function createEmploymentPeriodValue(baseValue: DocumentValueMap = {}): EmploymentPeriodValue {
  return {
    ...baseValue,
    ranges: [{ dateFrom: '', dateTo: '', days: 0 }],
    totalDays: 0
  };
}

// Gwarantuje minimum jeden wiersz w edytorze zakresów po otwarciu modala.
function prepareEmploymentPeriodSchema(schema: unknown): void {
  const schemaWithRanges = schema as SchemaWithRanges;
  const ranges = schemaWithRanges && schemaWithRanges.value && schemaWithRanges.value.ranges;

  if (ranges && Array.isArray(ranges.$items) && !ranges.$items.length && typeof ranges.$addRow === 'function') {
    ranges.$addRow();
  }
}

// Tworzy krótki opis widoczny na liście wartości dokumentu.
function formatEmploymentPeriodSummary(value: DocumentValueInput = {}): string {
  const model = normalizeEmploymentPeriodValue(value);
  return `${model.totalDays} dni`;
}

export const employmentPeriodEditorConfig: DocumentValueEditorConfig = {
  component: EmploymentPeriodEditor,
  modal: {
    size: 'xl',
    minHeight: '420px'
  },
  normalizeValue: normalizeEmploymentPeriodValue,
  createEmptyValue: createEmploymentPeriodValue,
  prepareSchema: prepareEmploymentPeriodSchema,
  formatSummary: formatEmploymentPeriodSummary
};
